import styled from 'styled-components'

export const HeaderRightWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .btns {
    display: flex;
    color: ${props => props.theme.isAlpha ? '#fff' : '#000'};
    .btn {
      padding: 5px 10px;
      cursor: pointer;
      &:hover {
        border-radius: 13px;
        background-color: rgba(255, 255, 255, 0.18);
      }
    }
  }

  .profile {
    position: relative;
    display: flex;
    align-items: center;
    border: 1px solid #eee;
    padding: 5px 5px 5px 12px;
    border-radius: 20px;
    background-color: #fff;
    cursor: pointer;

    ${(props) => props.theme.mixin.boxShadow} /* 阴影动画 */
    
    .icon {
      display: inline-block;
      color: ${(props) => props.theme.color.second};
    }
    .icon-list {
      width: 18px;
      height: 18px;
    }
    .icon-profile {
      width: 30px;
      height: 30px;
      margin-left: 10px;
    }

    /* 面板 */
    .panel {
      position: absolute;
      top: 50px;
      right: 0;
      width: 240px;
      background: #fff;
      border-radius: 10px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.18);
      padding: 10px 0;

      .item {
        padding: 0 10px;
        height: 40px;
        line-height: 40px;

        &:hover {
          background: #f5f6f7;
        }
      }

      .bottom {
        border-top: 1px solid #eee;
        margin-top: 5px;
        padding-top: 5px;
      }
    }
  }
`
